import { jsx as _jsx } from "react/jsx-runtime";
import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import { Result } from 'antd';
import { PageLoading } from 'components/atoms/loading';
import { Button } from 'components/facade/button';
import { MagicLinkGeneratePage } from 'components/molecules/session-setup';
import { RoutePaths } from 'constant';
import { useLoginWithToken } from 'hooks/use-login-with-token';
import { useQueryParams } from 'hooks/use-query-params';
import { useTranslation } from 'hooks/use-translation';
import { TokenType } from 'services';
export const SessionError = ()=>{
    return /*#__PURE__*/ _jsx(Result, {
        status: "error",
        title: useTranslation('session.error.title'),
        subTitle: useTranslation('session.error.message'),
        extra: [
            /*#__PURE__*/ _jsx(Button, {
                type: "primary",
                href: RoutePaths.newMagicLink,
                icon: /*#__PURE__*/ _jsx(ArrowRight16, {}),
                iconPlacement: "right",
                children: useTranslation('magic_link.new')
            }, "new-magic-link")
        ]
    });
};
export const MagicLinkPage = ()=>{
    var _params_get, _params_get1;
    const params = useQueryParams();
    const token = (_params_get = params.get('token')) !== null && _params_get !== void 0 ? _params_get : '';
    // In some cases customer will generate the token and pass it via url
    const extToken = (_params_get1 = params.get('rl-token')) !== null && _params_get1 !== void 0 ? _params_get1 : '';
    const tokenType = extToken ? TokenType.External : TokenType.Rocketlane;
    const [isLoading, isError] = useLoginWithToken(token || extToken || '', tokenType);
    if (isLoading) {
        return /*#__PURE__*/ _jsx(PageLoading, {});
    }
    return isError ? /*#__PURE__*/ _jsx(MagicLinkGeneratePage, {}) : null;
};
